import React, { useEffect, useState } from 'react';
import { List, Button, Modal, message, notification, Empty, Avatar, Typography, Popconfirm, Tag, Table, Card, Input,Row,Col,Breadcrumb } from 'antd';
import axios from 'axios';
import UserForm from './Form/UserForm';
import { useDeleteUserAdminPMutation, useGetAllUsersAdminPMutation, useGetAllUsersAdminPQuery } from '../../slices/adminApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setUsers } from '../../slices/usersSlice';
import { DeleteFilled, EditOutlined, UserAddOutlined, UserOutlined, SearchOutlined ,CodepenOutlined,DashOutlined,DashboardOutlined} from '@ant-design/icons';
// import { DeleteFilled, EditOutlined, UserAddOutlined, SearchOutlined ,DashboardOutlined} from '@ant-design/icons';

const AdminUsersScreen = () => {

    const { darkmode } = useSelector((state) => state.darkmode);
  
  const { Text ,Title} = Typography;
  const [api, contextHolder] = notification.useNotification();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { users } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  
const {
  data,
  isLoading: isUserLoading,refetch
} = useGetAllUsersAdminPQuery();
  console.log(data);
  
  const [deleteuser] = useDeleteUserAdminPMutation();

const getUsers = async () => {
  await refetch();
};  // console.log(getUsers);
  
  //   try {
  //     // const res = await getusers().unwrap();
  //     // console.log(res);
      
  //     dispatch(setUsers(data));
  //     // dispatch(setUsers({ ...res }));
  //   } catch (err) {
  //     console.log(err);
  //     api.error({
  //       message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
  //     });
  //   }
  // }

  // useEffect(() => {
    // getUsers();


    //   try {
    //   const res =  getusers();
    //   console.log(res);
      
    //   dispatch(setUsers(res.user));
    //   // dispatch(setUsers({ ...res }));
    // } catch (err) {
    //   console.log(err);
    //   api.error({
    //     message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
    //   });
    // }
  // }, []);

  const deleteUser = async (userId) => {
    try {
      await deleteuser({ userId }).unwrap();
      message.success('User deleted successfully');
      getUsers();
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setIsModalVisible(true);
  };

  const show = () => {
    setSelectedUser(null);
    setIsModalVisible(true);
  }

  const confirmd = (e, userId) => {
    deleteUser(userId);
  };

  // Columns for the table
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search ID"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button 
          onClick={() => {
            clearFilters();
            confirm(); // trigger confirm to refresh the table after clearing filters
          }}
          size="small" 
          style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, user) => user._id.toLowerCase().includes(value.toLowerCase()),
      width: '30%',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, user) => `${user.firstname} ${user.lastname}`,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Name"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button 
          onClick={() => {
            clearFilters();
            confirm(); // trigger confirm to refresh the table after clearing filters
          }}
          size="small" 
          style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, user) => `${user.firstname} ${user.lastname}`.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Email"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button 
          onClick={() => {
            clearFilters();
            confirm(); // trigger confirm to refresh the table after clearing filters
          }}
          size="small" 
          style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, user) => user.email.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      filters: [
        { text: 'Admin', value: 'Admin' },
        { text: 'User', value: 'User' },
      ],
      onFilter: (value, user) => user.role === value,
    },
      {
    title: 'Commission Rate (%)',
    dataIndex: 'CommissionRate',
    key: 'commission_rate',
    render: (rate, record) => record.role === 'Partner' ? `${rate}%` : '-', // only show for Partner
  },
    {
      title: 'Subscription Status',
      dataIndex: 'subscriptionStatus',
      key: 'subscriptionStatus',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (text, user) =>
        user.subscription.status === "active" ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
    },
    {
      title: 'Actions',
      key: 'actions',
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (text, user) => (
        <div>
          <Popconfirm
            title="Delete the user"
            description="Are you sure to delete this user?"
            onConfirm={(e) => confirmd(e, user.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger shape="circle" size='small' icon={<DeleteFilled />} />
          </Popconfirm>
          <Button
            onClick={() => handleEdit(user)}
            shape="circle"
            size='small'
            icon={<EditOutlined />}
            style={{ marginLeft: 8 }}
          />
        </div>
      ),
    },
  ];

  return (
    <>


      <Title
      style={{
        fontFamily: 'Inter, sans-serif',
        marginBottom: '16px', // Added margin below title
      }}
      level={2}
    >
     <UserOutlined />&nbsp;All users
    </Title>

    <Row
      style={{
        padding: "20px",
        backgroundColor: darkmode ? "#141414" : "#FFF",
        borderRadius: "5px",
        marginBottom: "20px", // Added spacing below breadcrumb row
      }}
    >
      <Col flex="auto">
        <Breadcrumb
          items={[{ title: 'users' }, { title: 'All users' }]}
          style={{ marginBottom: "5px" }}
        />
      </Col>
    </Row>

      {contextHolder}
      <Card title="All Users" extra={<Button type="primary" onClick={show} shape='circle'><UserAddOutlined /></Button>}>
        <Table
          columns={columns}
          size='small'
          // dataSource={users || []}
          dataSource={data?.users || []}
          loading={isUserLoading}
          rowKey={(user) => user._id}
          pagination={{ pageSize: 10 }}
          scroll={{ x: "scroll" }}
        />
      </Card>
      
      <Modal
        title={selectedUser ? 'Edit User' : 'Add User'}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <UserForm user={selectedUser} getUsers={getUsers} onClose={() => setIsModalVisible(false)} />
      </Modal>
    </>
  );
};

export default AdminUsersScreen;
